export default {
  setWicks: (state, payload) => { state.wicks = payload },
  setScents: (state, payload) => { state.scents = payload },
  setSizes: (state, payload) => { state.sizes = payload },
  setColors: (state, payload) => { state.colors = payload },
  setContainers: (state, payload) => { state.containers = payload },
  setPackages: (state, payload) => { state.packages = payload },
  setRefillContainers: (state, payload) => { state.refillContainers = payload },
}